import { lazy } from 'react';

export const StripechannelPage = lazy(() => import('./page-list'));